import React, { createContext, useContext } from "react";

type ModalContextType = {
  showTopBorder: boolean;
  setShowTopBorder: React.Dispatch<React.SetStateAction<boolean>>;
  showBottomBorder: boolean;
  setShowBottomBorder: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalContextProvider: React.FC<
  ModalContextType & { children: React.ReactNode }
> = ({
  children,
  showTopBorder,
  setShowTopBorder,
  showBottomBorder,
  setShowBottomBorder
}) => {
  const value = {
    showTopBorder,
    setShowTopBorder,
    showBottomBorder,
    setShowBottomBorder
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModalContext must be used within a Modal component");
  }
  return context;
};
